module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['our-services-tails', _vm.sub_class]
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row d-flex our-services-tails--title-desc"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.services), function(service, index) {
    return _c('div', {
      key: index,
      staticClass: "tail-desktop col-l-6"
    }, [_c('div', {
      staticClass: "tail-desktop__title"
    }, [_vm._v(_vm._s(service.name))]), _vm._v(" "), _c('div', {
      staticClass: "tail-desktop__image notched notched__enabled notched__inside notched__mobile-inside notched--bottom notched--mobile-middle notched--white",
      style: ({
        'background-image': 'url(' + service.image.url + ')',
        'background-position': service.horizontal_position +
          '% ' +
          service.vertical_position +
          '%',
      })
    }, [_c('div', {
      staticClass: "tail-desktop__image--caption",
      style: ({
        color: service.image_caption_color
      })
    }, [_vm._v("\n            " + _vm._s(service.image_caption) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "tail-desktop__description",
      domProps: {
        "innerHTML": _vm._s(service.description)
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.services), function(service, index) {
    return _c('div', {
      key: service.name,
      staticClass: "tail-mobile"
    }, [_c('div', {
      class: [
        'tail-mobile__title',
        {
          'tail-mobile__title-active': _vm.openAcordion === index
        } ],
      on: {
        "click": function($event) {
          return _vm.setActiveService(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(service.name) + "\n        ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openAcordion === index),
        expression: "openAcordion === index"
      }],
      staticClass: "tail-mobile__content"
    }, [_c('div', {
      staticClass: "tail-mobile__image notched notched__enabled notched__inside notched__mobile-outside notched--bottom notched--mobile-middle notched--white",
      style: ({
        'background-image': 'url(' + service.image.url + ')'
      })
    }, [_c('div', {
      staticClass: "tail-mobile__image--caption",
      style: ({
        color: service.image_caption_color
      })
    }, [_vm._v("\n              " + _vm._s(service.image_caption) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "notched-helper"
    })]), _vm._v(" "), _c('div', {
      staticClass: "tail-mobile__description",
      domProps: {
        "innerHTML": _vm._s(service.description)
      }
    })])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4aebb8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurServicesTails.vue
// module id = 367
// module chunks = 0